module.exports = __webpack_public_path__ + "static/media/chahua_2.98adc53c.svg";